import { FunctionComponent } from "react"
import { Alert, Col, Container, Row } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import { useNavigate, useParams } from "react-router-dom"
import { RouterExtended } from "../data/models"
import useLazyQuery from "../hooks/useLazyQuery"
import useQuery from "../hooks/useQuery"

interface ICancelStartPage {}
const CancelStartPage: FunctionComponent<ICancelStartPage> = () => {
	const navigate = useNavigate()
	const params = useParams()
	const routerId = params.routerId
	const routerQuery = useQuery<void, RouterQueryResponse>(`${process.env.REACT_APP_KNIT_URL}routers?id=${routerId}`)
	const router = routerQuery.data?.routers?.[0]
	const nextAgreementUrl = `${process.env.REACT_APP_KNIT_URL}agreements/${router?.nextAgreementId}`
	const deleteNextAgreementQuery = useLazyQuery<void, any>(nextAgreementUrl, "DELETE")
	//cancel start date function
	const cancelStart = async () => {
		await deleteNextAgreementQuery.query()
		navigate(-1)
	}
	//
	const error = deleteNextAgreementQuery.error || routerQuery.error
	//
	if (!routerQuery.data) {
		return (
			<Container style={{ maxWidth: 500 }}>
				<h2 className="text-center mt-4">Cancel Start of Internet Service</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Cancel Start of Internet Service</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<div className="text-center">
				Cancel start of internet service for {router?.propertyName} {router?.unitName}?
			</div>
			<Row className="mt-4">
				<Col xs="auto">
					<Button variant="secondary" disabled={deleteNextAgreementQuery.loading} onClick={() => navigate(-1)}>
						Cancel
					</Button>
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="primary" disabled={deleteNextAgreementQuery.loading || !!error} onClick={cancelStart}>
						{deleteNextAgreementQuery.loading ? "Saving" : "Confirm"}
					</Button>
				</Col>
			</Row>
		</Container>
	)
}

export default CancelStartPage

interface RouterQueryResponse {
	routers: RouterExtended[]
}
